// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductIcon_container__oXenO","productIcon":"ProductIcon_productIcon__sfNz3"};